import React, { forwardRef } from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export const RefreshIcon = forwardRef(function RefreshIcon(
  { className, fill = 'none', height, stroke = IconColors.DarkGrey, width }: SimpleIconInterface,
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  return (
    <SimpleIcon
      ref={ref}
      className={className}
      fill={fill}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M12.0789 2.25c-4.7935 0 -8.73412 3.663 -9.11835 8.3333h-0.96053c-0.30388 0 -0.57773 0.1834 -0.69347 0.4644 -0.11574 0.281 -0.05049 0.604 0.16523 0.818l1.67981 1.6667c0.29241 0.2901 0.76408 0.2901 1.05649 0l1.67981 -1.6667c0.21572 -0.214 0.28097 -0.537 0.16523 -0.818 -0.11574 -0.281 -0.38959 -0.4644 -0.69347 -0.4644H4.4668C4.84652 6.75167 8.10479 3.75 12.0789 3.75c2.7695 0 5.1938 1.45845 6.5367 3.64279 0.2169 0.35286 0.6788 0.46306 1.0317 0.24613 0.3529 -0.21693 0.4631 -0.67885 0.2461 -1.03171C18.2871 3.99427 15.3873 2.25 12.0789 2.25Z"
        fill={stroke}
        stroke-width="1"
      ></path>
      <path
        d="M20.8411 10.4666c-0.2921 -0.2888 -0.7622 -0.2888 -1.0544 0l-1.6862 1.6667c-0.2164 0.2138 -0.2821 0.537 -0.1666 0.8184 0.1156 0.2813 0.3896 0.465 0.6938 0.465h0.8991c-0.3813 3.8295 -3.6509 6.8333 -7.644 6.8333 -2.78254 0 -5.21694 -1.4597 -6.56484 -3.6439 -0.21754 -0.3525 -0.67963 -0.4619 -1.03213 -0.2443 -0.35249 0.2175 -0.4619 0.6796 -0.24437 1.0321C5.65407 20.007 8.56406 21.75 11.8828 21.75c4.8078 0 8.7647 -3.6608 9.1503 -8.3333h0.9671c0.3041 0 0.5781 -0.1837 0.6937 -0.465 0.1156 -0.2814 0.0498 -0.6046 -0.1665 -0.8184l-1.6863 -1.6667Z"
        fill={stroke}
        stroke-width="1"
      ></path>
    </SimpleIcon>
  );
});
